import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.p3p_1 = new (CouplingImages())('overlayPng', 'graphqlSvg', 'logoSvg', 'noPartyImagePath', 'noPlayerImagePath', 'frodo', 'samwise', 'grayson', 'wayne', 'rosie', 'wendy', 'robPng', 'autumnPng');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var CouplingImagesClass;
function CouplingImages() {
  if (CouplingImagesClass === VOID) {
    class $ {
      constructor(overlayPng, graphqlSvg, logoSvg, noPartyImagePath, noPlayerImagePath, frodo, samwise, grayson, wayne, rosie, wendy, robPng, autumnPng) {
        Companion_getInstance();
        this.c3p_1 = overlayPng;
        this.d3p_1 = graphqlSvg;
        this.e3p_1 = logoSvg;
        this.f3p_1 = noPartyImagePath;
        this.g3p_1 = noPlayerImagePath;
        this.h3p_1 = frodo;
        this.i3p_1 = samwise;
        this.j3p_1 = grayson;
        this.k3p_1 = wayne;
        this.l3p_1 = rosie;
        this.m3p_1 = wendy;
        this.n3p_1 = robPng;
        this.o3p_1 = autumnPng;
      }
      toString() {
        return 'CouplingImages(overlayPng=' + this.c3p_1 + ', graphqlSvg=' + this.d3p_1 + ', logoSvg=' + this.e3p_1 + ', noPartyImagePath=' + this.f3p_1 + ', noPlayerImagePath=' + this.g3p_1 + ', frodo=' + this.h3p_1 + ', samwise=' + this.i3p_1 + ', grayson=' + this.j3p_1 + ', wayne=' + this.k3p_1 + ', rosie=' + this.l3p_1 + ', wendy=' + this.m3p_1 + ', robPng=' + this.n3p_1 + ', autumnPng=' + this.o3p_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.c3p_1);
        result = imul(result, 31) + getStringHashCode(this.d3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.e3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.f3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.g3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.h3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.i3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.j3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o3p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CouplingImages()))
          return false;
        if (!(this.c3p_1 === other.c3p_1))
          return false;
        if (!(this.d3p_1 === other.d3p_1))
          return false;
        if (!(this.e3p_1 === other.e3p_1))
          return false;
        if (!(this.f3p_1 === other.f3p_1))
          return false;
        if (!(this.g3p_1 === other.g3p_1))
          return false;
        if (!(this.h3p_1 === other.h3p_1))
          return false;
        if (!(this.i3p_1 === other.i3p_1))
          return false;
        if (!(this.j3p_1 === other.j3p_1))
          return false;
        if (!(this.k3p_1 === other.k3p_1))
          return false;
        if (!(this.l3p_1 === other.l3p_1))
          return false;
        if (!(this.m3p_1 === other.m3p_1))
          return false;
        if (!(this.n3p_1 === other.n3p_1))
          return false;
        if (!(this.o3p_1 === other.o3p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CouplingImages');
    CouplingImagesClass = $;
  }
  return CouplingImagesClass;
}
//region block: exports
export {
  CouplingImages as CouplingImagesci5yi3b0zpw0,
  Companion_getInstance as Companion_getInstance2v2254ph1bmtz,
};
//endregion

//# sourceMappingURL=CouplingImages.mjs.map
